import { useEffect, useState } from 'react';
import useGetSalPlanning from '../_hooks/sal-hooks/useGetSalPlanning';
import useFormSalPlanning from 'shared/design-system/components/app-accordion/_hooks/useFormSalPlanning';
import FiltersDashboardSal, { filtersDashboardSalData } from '../_components/filters-dashboard-sal';
import usePagination from 'core/hooks/usePagination';
import useSortDashboardProjects from '../_hooks/projects-hooks/useSortDashboardProjects';
import { useTranslation } from 'react-i18next';
import AppAccordion from 'shared/design-system/components/app-accordion';
import { LocationFilterEnum } from 'enums/global.enum';
import NoData from 'shared/design-system/components/no-data-box';
import AppPaginator from 'shared/design-system/components/app-paginator';
import { Table } from 'react-bootstrap';
import React from 'react';
import { formatCurrency, getFormattedDateHeader } from 'shared/utils/common.utils';
import { StorageKeysEnum } from 'enums/storageKeys.enum';
import { RptSalPlannedOutputDto } from '@api/client';
import { format } from 'date-fns';
import { PathEnum } from 'core/router/path.enum';
import { Tooltip } from 'antd';
import './styles.scss';
import { dashboardConfig } from '../_config/dashboard.config';

const PAGE_SIZE = dashboardConfig.defaultPageSize;

const SalPlanning: React.FC = () => {
  const { t } = useTranslation();

  const [sort, setSort] = useState<number>(1);
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const { onSubmit, onReset, chipsFormData, setChipsFormData, reset, filterParams } =
    useFormSalPlanning(filtersDashboardSalData);

  const { projects, allMonths, setProjects, totaliMese, totaleGenerale } = useGetSalPlanning();

  const {
    pageNumber: pageNumberProject,
    setPageNumber: setPageNumberProject,
    totalPages: totalPagesProject,
    visibleItems: visibleProjects,
  } = usePagination(projects, PAGE_SIZE, null, sort);

  const [visProj, setVisProj] = useState(visibleProjects);

  const { sortItems } = useSortDashboardProjects(projects, setProjects as any);

  useEffect(() => {
    if (visibleProjects) {
      setVisProj(visibleProjects);
    }
  }, [visibleProjects]);

  const handleReset = () => {
    onReset();
    chipsFormData && setChipsFormData([]);
  };

  return (
    <div>
      <AppAccordion
        formData={filtersDashboardSalData}
        location={LocationFilterEnum.DASHBOARD_SAL_PLANNING}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        chipsFormData={chipsFormData}
        setChipsFormData={setChipsFormData}
        reset={reset}
      >
        <FiltersDashboardSal onSubmit={onSubmit} handleReset={handleReset} />
      </AppAccordion>
      {projects.length === 0 ? (
        <div className="mt-3">
          <NoData msg={t('project-list.no-projects')} />
        </div>
      ) : (
        <>
          <div className="d-flex" style={{ overflowX: 'auto' }}>
            <Table bordered className="revenue-table sticky-table test-table mt-0 mb-0">
              <thead style={{ height: '80px' }}>
                <tr>
                  <th style={{ minWidth: '350px' }}>{t('dashboard.resources.table-titles.name')}</th>
                </tr>
              </thead>
              <tbody>
                {visProj?.map((project: RptSalPlannedOutputDto, index: number) => (
                  <React.Fragment key={`${project.denominazioneProgetto}${index}`}>
                    <tr>
                      <td className="align-middle">
                        <div className="d-flex project-name">
                          <a
                            href={`${window.location.origin}${window.location.pathname}#/${PathEnum.PRIVATE}/${PathEnum.PROGETTI}/${project?.pkProgetto}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-links align-self-center"
                          >
                            {`(${project.pkProgetto}) ${project.denominazioneProgetto}`}
                          </a>
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
                <tr>
                  <td>
                    <div className="d-flex">
                      <div className="container-dashboard project-name" style={{ fontWeight: '800' }}>
                        {t('dashboard.resources.table-titles.total')}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </Table>
            <Table bordered className="revenue-table test-table mt-0 mb-0">
              <thead>
                <tr>
                  {allMonths.map((date) => (
                    <th key={`${date.month}-${date.year}`} style={{ minWidth: '70px' }} colSpan={2}>
                      {getFormattedDateHeader(date.month, date.year)}
                    </th>
                  ))}

                  <th>{t('dashboard.resources.table-titles.total')}</th>
                </tr>
                <tr>
                  {allMonths.map((date) => (
                    <React.Fragment key={`${date.month}-${date.year}`}>
                      <th id="plannedDate" style={{ whiteSpace: 'nowrap' }}>
                        {t('Planned date')}
                      </th>
                      <th id="amountSAL">{t('Amount')}</th>
                    </React.Fragment>
                  ))}
                  <th id="totalAmount">{t('Amount')}</th>
                </tr>
              </thead>
              <tbody>
                {visProj?.map((project: RptSalPlannedOutputDto, index: number) => (
                  <React.Fragment key={`${project.denominazioneProgetto}${index}`}>
                    <tr>
                      {project.rptSalPlannedMeseAnnoImportoOutputDtoList?.map((month) => (
                        <React.Fragment key={`${month.mese}-${month.anno}`}>
                          <td>
                            <div className="container-dashboard">
                              {month.dataInvioSal ? format(month.dataInvioSal, 'dd/MM/yyyy') : '-'}
                            </div>
                          </td>
                          <td key={`${month.mese}-${month.anno}`}>
                            <div className="d-flex justify-content-between align-items-center w-100">
                              {month.salInviato && (
                                <Tooltip title={t('SAL Sent')} color="white">
                                  <i
                                    className="fa fa-circle-check text-success me-2"
                                    aria-hidden="true"
                                    title={t('Sent')}
                                  />
                                </Tooltip>
                              )}
                              <div className="container-dashboard text-end flex-grow-1">
                                <span style={{ whiteSpace: 'nowrap' }}>{`€ ${
                                  formatCurrency(month.salImporto) || '-'
                                }`}</span>
                              </div>
                            </div>
                          </td>
                        </React.Fragment>
                      ))}

                      <td>
                        <div className="container-dashboard text-end" style={{ fontWeight: '800' }}>
                          {`€ ${formatCurrency(
                            project.rptSalPlannedMeseAnnoImportoOutputDtoList?.reduce(
                              (acc, month) => acc + (month.salImporto || 0),
                              0
                            )
                          )}`}
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
                <tr>
                  {allMonths.map((date) => {
                    const totaleMese = totaliMese.find(
                      (t) => t.mese === date.month && t.anno === date.year
                    );
                    return (
                      <React.Fragment key={`${date.month}-${date.year}`}>
                        <td key={`${date.month}-${date.year}`} colSpan={2}>
                          <div
                            className="container-dashboard text-end"
                            style={{ fontWeight: '800', whiteSpace: 'nowrap' }}
                          >
                            {`€ ${formatCurrency(totaleMese?.totaleSal) || '-'}`}
                          </div>
                        </td>
                      </React.Fragment>
                    );
                  })}
                  <td>
                    <div className="container-dashboard text-end" style={{ fontWeight: '800', whiteSpace: 'nowrap' }}>
                      {`€ ${formatCurrency(totaleGenerale)}`}
                    </div>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
          {visibleProjects?.length > 0 ? (
            <AppPaginator
              keyPaginator={StorageKeysEnum.CURRENT_PAGE_SAL_PLANNING}
              currentPage={pageNumberProject}
              totalPages={totalPagesProject}
              totalElements={projects?.length || 0}
              pageSize={PAGE_SIZE}
              onPageChange={setPageNumberProject}
            />
          ) : (
            ''
          )}
        </>
      )}
    </div>
  );
};

export default SalPlanning;
